import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import ArticlePagesBlockData from '../../../Models/Content/ArticlePagesBlockData';
import {ArticlePagesBlockMain} from "./ArticlePagesBlockMain";

export default class ArticlePagesBlock extends EpiComponent<ArticlePagesBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <ArticlePagesBlockMain context={this.getContext()} contentData={this.props.data} />;
  }
}
